module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1152.68252c0d.png";